import { useEffect, useState } from "react";
import { useGestionConocimientos } from "../../../hooks/gestionConocimientos/useGestionConocimientos"
import { ContenedorParametros } from "../../components/utils/ContenedorParametros"
import { BotonNuevo } from "../../components/buttons/BotonNuevo";
import { BotonProcesar } from "../../components/buttons/BotonProcesar";
import { ContenedorTabla } from "../../components/utils/ContenedorTabla";
import { Modal } from "../../components/modal/Modal";
import { useModal } from "../../../hooks/useModal";
import { DatePickerABX } from "../../components/pickers/DatePicker";
import { notify } from "../../../utils/utils";

export const InventarioServicios = ()  => {
    const [ valorEstado, setValorEstado ] = useState(0);
    const [ valorPestania, setValorPestania ] = useState(0);
    const [ isOpenModalServicio, openModalServicio, closeModalServicio ] = useModal(null);
    const [ isOpenModalEliminarServicios, openModalEliminarServicios, closeModalEliminarServicios ] = useModal(null);
    const datosEliminarDefault = {
        codGestionConocimiento: 0,
        motivoEliminacion: ""
    }
    const [ datosEliminar, setDatosEliminar ] = useState(datosEliminarDefault)
    const editarValorEliminacion = (key,value) =>{
        setDatosEliminar(leccion => {
            return {
                ...leccion,
                [key]: value
            }
        })
    }

    const idTabla = 'TablaServicios'
    const classNameInput = "py-1 px-2 caret-white containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:opacity-70 disabled:cursor-not-allowed";
    const classNameSelect = "py-1 px-2 containerScroll text-white  rounded  bg-zinc-900 text-l focus:outline-none focus:ring-1 focus:ring-blue-500";
    const pestaniasServicios = [
        { nombre: "General", valor: 0 },
        { nombre: "Control de versiones", valor: 1 },
        { nombre: "Despliegue", valor: 2 },
    ]


    const {
        listarEstados,
        listaEstadoConocimiento,
        listarServiciosGeneral,
        serviciosGeneral,
        listarDetalleServicio,
        detalleServicio,
        editarValorServicio,
        listarTipoServicios,
        listaTipoServicios,
        listarLenguajeProgramacion,
        listaLenguajeProgramacion,
        listarSistemaOperativo,
        listaSistemaOperativo,
        listarlistaPlataformaDespliegue,
        listaPlataformaDespliegue,
        listarComboServidores,
        listaServidores,
        listarFramework,
        listaFramework,
        listarDominiosCombo,
        listaDominios,
        listarMotorBaseDatos,
        listaMotorBD,
        listaDominioSubDom,
        listarDominioSubdominio,
        guardarServicio,
        eliminarServicio,



    } = useGestionConocimientos();

    useEffect(() => {
        listarDominiosCombo();
        listarFramework();
        listarComboServidores();
        listarlistaPlataformaDespliegue();
        listarSistemaOperativo();
        listarLenguajeProgramacion();
        listarTipoServicios();
        listarEstados();
        listarServiciosGeneral(0);
        listarMotorBaseDatos();
        listarDominioSubdominio();
    },[])

    const VistaGeneral = () => (
        <>
            <div className={`${valorPestania === 0 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="nomProyecto">Proyecto</label>
                <input
                    id="nomProyecto"
                    value={detalleServicio.nomProyecto}
                    onChange={(e) => editarValorServicio('nomProyecto', e.target.value)}
                    className={classNameInput}
                />
                <label htmlFor="nomAplicacion">Aplicación</label>
                <input
                    id="nomAplicacion"
                    value={detalleServicio.nomAplicacion}
                    onChange={(e) => editarValorServicio('nomAplicacion', e.target.value)} 
                    className={classNameInput}
                />
                <label htmlFor="selectTipoAplicacion">Tipo aplicación</label>
                <select
                    id="selectTipoAplicacion"
                    value={detalleServicio.codTipoAplicacion}
                    onChange={(e) => editarValorServicio('codTipoAplicacion', Number(e.target.value))}
                    className={classNameSelect}
                >
                    <option value={0} key={'opcionSeleccioneServicio'}>--Seleccione--</option>
                    {
                        listaTipoServicios.length > 0 ? 
                            listaTipoServicios.map(ser => (
                                <option key={ser.codTipoAplicacion} value={ser.codTipoAplicacion}>{ser.nomTipoAplicacion}</option>
                            ))
                        :
                            <></>
                    }

                </select>
                <label htmlFor="versionActual">Versión actual</label>
                <input
                    id="versionActual"
                    value={detalleServicio.versionActual}
                    onChange={(e) => editarValorServicio('versionActual', e.target.value)}
                    className={classNameInput}
                />
                <div className="col-span-4 grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center">
                    <label htmlFor="contacto">Contacto</label>
                    <input
                        id="contacto"
                        value={detalleServicio.contacto}
                        onChange={(e) => editarValorServicio('contacto', e.target.value)}
                        className={classNameInput}
                    />
                </div>
                <label htmlFor="descripcion">Descripción</label>
                <textarea
                    id="descripcion"
                    className={classNameInput + ' h-[100px] resize-none col-span-3'}
                    value={detalleServicio.descripcion}
                    onChange={(e) => editarValorServicio('descripcion', e.target.value)}
                />
                <label htmlFor="observacion">Observación</label>
                <textarea
                    id="observacion"
                    className={classNameInput + ' h-[100px] resize-none col-span-3'}
                    value={detalleServicio.observaciones}
                    onChange={(e) => editarValorServicio('observaciones', e.target.value)}
                />
            </div>
        </>
    );

    const VistaControlVersiones = () => (
        <>
            <div className={`${valorPestania === 1 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="lenguaje">Lenguaje</label>
                <select
                    id="lenguaje"
                    value={detalleServicio.codLenguajeProgramacion}
                    onChange={(e) => editarValorServicio('codLenguajeProgramacion', Number(e.target.value))}
                    className={classNameInput}
                >
                    <option value={0} key={'opcionSeleccioneLenguaje'}>--Seleccione--</option>
                    {
                        listaLenguajeProgramacion.length > 0 ? 
                            listaLenguajeProgramacion.map(len => (
                                <option value={len.codLenguajeProgramacion} key={len.codLenguajeProgramacion}>{len.nomLenguajeProgramacion}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="ctaPropietario">Cta propietario</label>
                <input
                    id="ctaPropietario"
                    value={detalleServicio.cuentaPropietario}
                    onChange={(e) => editarValorServicio('cuentaPropietario', e.target.value)}
                    className={classNameInput}
                />
                <label htmlFor="repositorio">Repositorio git</label>
                <input
                    id="repositorio"
                    value={detalleServicio.repositorio}
                    onChange={(e) => editarValorServicio('repositorio', e.target.value)}
                    className={classNameInput}
                />
            </div>
        </>
    );
    
    const VistaDespliegue = () => (
        <>
            <div className={`${valorPestania === 2 ? '' : 'hidden'} grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)_minmax(0,2fr)_minmax(0,3fr)] gap-2 items-center`}>
                <label htmlFor="selectlistaSistemaOperativo">Plataforma host</label>
                <select
                    id="selectlistaSistemaOperativo"
                    className={classNameSelect}
                    value={detalleServicio.codTipoOS}
                    onChange={(e) => editarValorServicio('codTipoOS', Number(e.target.value))}
                >
                    <option value={0} key={'opcionSeleccioneHost'}>--Seleccione--</option>
                    {
                        listaSistemaOperativo.length > 0 ? 
                            listaSistemaOperativo.map(so => (
                                <option key={'tipoOS' + so.codTipoOS} value={so.codTipoOS}>{so.nomTipoOS}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="selectPlataforma">Plataf. despliegue</label>
                <select
                    id="selectPlataforma"
                    className={classNameSelect}
                    value={detalleServicio.codPlataforma}
                    onChange={(e) => editarValorServicio('codPlataforma', Number(e.target.value))}
                >
                    <option value={0} key={'opcionSeleccioneDespliegue'}>--Seleccione--</option>
                    {
                        listaPlataformaDespliegue.length > 0 ? 
                            listaPlataformaDespliegue.map(desp => (
                                <option key={desp.codPlataforma} value={desp.codPlataforma}>{desp.nomPlataforma}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="selectFrame">Framework</label>
                <select
                    id="selectFrame"
                    className={classNameSelect}
                    value={detalleServicio.codFramework}
                    onChange={(e) => editarValorServicio('codFramework', Number(e.target.value))} 
                >
                    <option value={0} key={'opcionSeleccioneFramework'}>--Seleccione--</option>
                    {
                        listaFramework.length > 0 ?
                            listaFramework.map(fr => (
                                <option value={fr.codFramework} key={fr.codFramework}>{fr.frameWork}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="versionFrame">V. framework</label>
                <input
                    id="versionFrame"
                    className={classNameInput}
                    value={detalleServicio.versionFramework}
                    onChange={(e) => editarValorServicio('versionFramework', e.target.value)}
                />
                <label htmlFor="selectServidor">Servidor</label>
                <select
                    id="selectServidor"
                    className={classNameSelect}
                    value={detalleServicio.codGestionInfraestructuraServidor}
                    onChange={(e) => editarValorServicio('codGestionInfraestructuraServidor', e.target.value)}
                >
                    <option value={0} key={'opcionSeleccioneServidor'}>--Seleccione--</option>
                    {
                        listaServidores.length > 0 ? 
                        listaServidores.map(serv => (
                                <option key={serv.codGestionInfraestructuraServidor} value={serv.codGestionInfraestructuraServidor}>{serv.nomServidor}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="urlAcceso">URL acceso</label>
                <input
                    id="urlAcceso"
                    className={classNameInput}
                    value={detalleServicio.urlAcceso}
                    onChange={(e) => editarValorServicio('urlAcceso', e.target.value)}
                />
                <label htmlFor="fechaAlta">Fecha de alta</label>
                <DatePickerABX
                    setDate={editarValorServicio}
                    date={detalleServicio.fechaAlta}
                    keyDate={'fechaAlta'}
                    ocultarIcono={true}
                    classNameInput={`${classNameInput} w-[189px]`}
                />
                <label htmlFor="fechaUltimaActualizacion">Fecha ult. actual.</label>
                <DatePickerABX
                    setDate={editarValorServicio}
                    date={detalleServicio.fechaUltimaActualizacion}
                    keyDate={'fechaUltimaActualizacion'}
                    ocultarIcono={true}
                    classNameInput={`${classNameInput} w-[189px]`}
                />
                <label htmlFor="nomDependencia">Dependencia</label>
                <input
                    id="nomDependencia"
                    className={classNameInput}
                    value={detalleServicio.nomDependencia}
                    onChange={(e) => editarValorServicio('nomDependencia', e.target.value)}
                />
                <label htmlFor="selectEntorno">Dominio</label>
                <select
                    id="selectEntorno"
                    className={classNameSelect}
                    value={detalleServicio.codGestionInfraestructuraDomAux}
                    onChange={(e) => {
                        editarValorServicio("codGestionInfraestructuraDomAux", Number(e.target.value))
                        editarValorServicio("codDominioJerarquia", Number(e.target.options[e.target.selectedIndex].getAttribute("data-jerarquia")))
                    }}
                >
                    <option value={0} key={'opcionSeleccioneDominio'} data-jeraquia={0}>--Seleccione--</option>
                    {
                        listaDominioSubDom.length > 0 ? 
                            listaDominioSubDom.map(serv => (
                                <option
                                    value={serv.codGestionInfraestructuraDomAux}
                                    data-jerarquia={serv.codDominioJerarquia}
                                    key={'domsub_' + serv.codGestionInfraestructuraDomAux}
                                >{serv.nomDomAux}</option>
                            ))
                        :
                            <></>
                    }
                </select>
                <label htmlFor="bdRelacionada">BD relacionada</label>
                <select
                    id="bdRelacionada"
                    className={classNameSelect}
                    value={detalleServicio.codMotorBaseDatos}
                    onChange={(e) => editarValorServicio('codMotorBaseDatos', e.target.value)}
                >
                    <option value={0} key={'optionSelecciooneBD'}>--Seleccione--</option>
                    {
                        listaMotorBD.length > 0 ? 
                            listaMotorBD.map((bd, i) => (
                                <option value={bd.codMotorBaseDatos} key={'bd_' + bd.codMotorBaseDatos}>{bd.nomMotorBaseDatos}</option>
                            ))
                        : 
                            <></>
                    }
                </select>
                <label htmlFor="manualUsuario">Manual de usu.</label>
                <input
                    id="manualUsuario"
                    className={classNameInput + ' placeholder:text-xs '}
                    value={detalleServicio.manualUsuario}
                    onChange={(e) => editarValorServicio('manualUsuario', e.target.value)}
                    placeholder="Inserte url de manual de usuario"
                />
                <label htmlFor="documentacion">Documentación</label>
                <input
                    id="documentacion"
                    className={classNameInput}
                    value={detalleServicio.documentacion}
                    onChange={(e) => editarValorServicio('documentacion', e.target.value)}
                />
            </div>
        </>
    );

    const seleccionarVista = () => {
        switch(valorPestania){
            case 0: return VistaGeneral();
            case 1: return VistaControlVersiones();
            case 2: return VistaDespliegue();
            default: return VistaGeneral();
        }
    }

    const labelEstado = (codEstado, nomEstado) => {
        let color = ' bg-gray-600 ';
        switch(codEstado){
            case 1: color = ' bg-green-600 ';
            break;
            case 10: color = ' bg-red-600 ';
            break;
            default: color = ' bg-yellow-600 '
        }
        return <span className={`inline-block w-[60px] ${color} px-2 rounded text-center`}>{nomEstado}</span>
    }

    const registrarServicio = async () => {
        const isValid = await guardarServicio();
        if(isValid)
        {
            closeModalServicio();
            listarServiciosGeneral(valorEstado);
        }
    }

    const eliminarRegistro = async () => {
        const camposAValidar = ["motivoEliminacion"];
        const validarEliminacion = camposAValidar.some(campo => datosEliminar[campo] === "" || datosEliminar[campo] === null || datosEliminar[campo] === 0 || datosEliminar[campo] === undefined);
        if(validarEliminacion){
            notify("Falta completar datos del formulario", "warning");
            return
        }
        const isValid = await eliminarServicio(detalleServicio.codGestionInfraestructuraAplicacion, datosEliminar.motivoEliminacion);
        if(isValid){
            await listarServiciosGeneral();
            closeModalEliminarServicios();
        }
    }

    return(
        <>
            <ContenedorParametros
                titulo='Inventario de servicios General'
                tablaId={idTabla}
            >
                <i className="fa fa-filter"></i>                                                                                                                                                                                        
                <select
                    className={`${classNameSelect}`}
                    onChange={(e) => {
                        setValorEstado(Number(e.target.value))
                        listarServiciosGeneral(Number(e.target.value))
                    }}
                >
                    <option key={'todo'} value={0}>-- Todos --</option>
                    {
                        listaEstadoConocimiento.length > 0 ?
                            listaEstadoConocimiento.map(es => (
                                <option key={'estado_' + es.codEstado} value={es.codEstado}>{es.nomEstado}</option>
                            ))
                        : <></>
                    }
                </select>
                <BotonNuevo 
                    onClick={()=> {
                        setValorPestania(0)
                        listarDetalleServicio()
                        openModalServicio()
                    }}
                />
                <BotonProcesar onClick={()=> listarServiciosGeneral(valorEstado)}/>
            </ContenedorParametros>
            <ContenedorTabla>
                <table className="table" id={idTabla}>
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>CÓDIGO</th>
                            <th>PROYECTO</th>
                            <th>APLICACIÓN</th>
                            <th>T.APLICACIÓN</th>
                            <th>VERSIÓN</th>
                            <th>LENGUAJE</th>
                            <th>SISTEMA OPERATIVO</th>
                            <th>PLATAFORMA</th>
                            <th>F. ACTUALIZACIÓN</th>
                            <th>ESTADO</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            serviciosGeneral.length > 0 ? 
                                serviciosGeneral.map((ser, i) => (
                                    <tr className="content ">
                                        <td className="w-[40px]">{i + 1}</td>
                                        <td className="w-[80px] min-w-[80px] text-center">
                                            <span className=" inline-block rounded bg-blue-600 w-[70px] text-center">{ser.codigoAplicacion}</span>
                                        </td>
                                        <td className="w-[350px] min-w-[340px] max-w-[350px] text-left">
                                            <div className="whitespace-nowrap w-[95%] text-ellipsis overflow-hidden">{ser.nomProyecto}</div>
                                        </td>
                                        <td className="w-[300px] min-w-[280px] max-w-[300px] text-left">
                                            <div className="whitespace-nowrap w-[95%] text-ellipsis overflow-hidden">{ser.nomAplicacion}</div>
                                        </td>
                                        <td className="w-[200px] min-w-[190px] max-w-[200px] text-left">
                                            <div className="whitespace-nowrap w-[95%] text-ellipsis overflow-hidden">{ser.tipoAplicacion}</div>
                                        </td>
                                        <td className="w-[60px] text-center">{ser.versionActual}</td>
                                        <td className="w-[90px] min-w-[90px] text-center">{ser.nomLenguajeProgramacion}</td>
                                        <td className="w-[200px] min-w-[180px] max-w-[200px] text-center">{ser.nomTipoOS}</td>
                                        <td className="w-[150px] min-w-[130px] max-w-[150px] text-center">{ser.nomPlataforma}</td>
                                        <td className="w-[150px] min-w-[140px] max-w-[150px] text-center">{ser.fechaUltimaActualizacion}</td>
                                        <td className="w-[80px] min-w-[75px] max-w-[80px] text-left">{labelEstado(ser.codEstado,ser.nomEstado)}</td>
                                        <td>
                                            <i
                                                className="fa fa-edit text-blue-600 text-base"
                                                onClick={() => {
                                                    setValorPestania(0);
                                                    listarDetalleServicio(ser);
                                                    openModalServicio();
                                                }}
                                            ></i>
                                        </td>
                                        <td>
                                            <i
                                                className="fa fa-trash text-red-600 text-base"
                                                onClick={()=> {
                                                    listarDetalleServicio(ser);
                                                    openModalEliminarServicios();
                                                }}
                                            ></i>
                                        </td>
                                    </tr>
                                ))
                            :
                                <tr><td colSpan={21} className="text-center">No hay información para mostrar...</td></tr>
                        }
                    </tbody>
                </table>
            </ContenedorTabla>

            <Modal
                isOpen={isOpenModalServicio}
                closeModal={closeModalServicio}
                action={()=> registrarServicio()}
                textButtons={{ confirm: 'Guardar', denied: 'Cancelar' }}
                validButton={{ confirm: true, denied: true }}
                title={detalleServicio.codGestionInfraestructuraAplicacion == 0 ? 'Nuevo registro' : `[${detalleServicio.codigoAplicacion}] Editar servicio`}
            >
                <section className="w-[700px] h-[450px] bg-zinc-800 px-2 grid grid-rows-[minmax(0,2fr)_minmax(0,8fr)]">
                    <section className="flex mx-2 gap-1 border-b-[2px] border-b-zinc-600 ">
                        {
                            pestaniasServicios.map((data, i) => (
                                <button
                                    key={'btn_' + i}
                                    className={`btnActive px-2 py-3 ${valorPestania === i ? 'border-b-[2px] ' : ''} border-blue-500`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setValorPestania(i);
                                    }}
                                >{data.nombre}</button>
                            ))
                        }
                    </section>
                    <section className="p-2 ">
                        {
                            seleccionarVista()
                        }
                    </section>
                </section>

            </Modal>

            {/* MODAL PARA ELIMINAR SERVICIO */}
            <Modal
                isOpen={isOpenModalEliminarServicios}
                closeModal={closeModalEliminarServicios}
                action={() => eliminarRegistro()}
                title={`[${detalleServicio.codigoAplicacion}] Eliminar Servicio`}
                textButtons={{confirm: 'Guardar', denied: 'Cancelar'}}
            >
                <div className='grid gap-2 py-3 w-[350px]'>
                    <strong className="">Motivo:</strong>
                    <textarea
                        className={`${classNameInput}
                        h-[80px] resize-none`}
                        placeholder="Escriba aquí el motivo de la eliminación de leccion y aprendizaje..."
                        onChange={(e) => editarValorEliminacion('motivoEliminacion', e.target.value)}
                    />
                </div>
            </Modal>
        </>
    )
}